<template>
    <Modal ref="modal" class="mark-order-not-paid-modal" @closed="onModalClose">
        <template #header="sp">
            <div class="h3">Marquer la commande comme NON payée d'avance</div>
        </template>
        <template #body="sp">
            <div class="form-group row">
                <label for="staticCustomerName" class="col-4 col-form-label">Client</label>
                <div class="col-8">
                    <input type="text" readonly class="form-control-plaintext" id="staticCustomerName" :value="order.customer.name">
                </div>
            </div>

            <div class="form-group row">
                <label for="staticDeliveryDate" class="col-4 col-form-label">Date de livraison</label>
                <div class="col-8">
                    <input type="text" readonly class="form-control-plaintext" id="staticDeliveryDate" :value="formatDate(order.delivery_date)">
                </div>
            </div>

            <ErrorsZone :errors="errors" />
        </template>
        <template #footer>
            <AuthorizationModal
                token-type="MarkOrderNotPaid"
                :token-payload="authorizationTokenPayload"
                @authorised="onAuthorizationModalAuthorize"
            >
                <template #button="sp">
                    <AuthorizationModalButton class="btn-warning" @click="onClickButton(sp)">
                        Marquer la commande comme NON payée d'avance
                    </AuthorizationModalButton>
                </template>
            </AuthorizationModal>
        </template>
    </Modal>
</template>

<script>
    import Modal from "../../Modal";
    import ErrorsZone from "../../ErrorsZone";
    import AuthorizationModal from "../../AuthorizationModal";
    import AuthorizationModalButton from "../../AuthorizationModalButton";

    import {usePostRequest} from "../../compositions/axios/postRequest";

    export default {
        name: 'MarkOrderNotPaidModal',

        components: {
            Modal,
            ErrorsZone,
            AuthorizationModal,
            AuthorizationModalButton,
        },

        setup() {
            const {
                loading: sending,
                errors,
                post
            } = usePostRequest();

            return {
                sending,
                errors,
                post
            };
        },

        props: {
            order: {
                type: Object,
                required: true,
            },
        },

        methods: {
            showModal() {
                this.$refs.modal.showModal();
            },

            closeModal() {
                this.$refs.modal.closeModal();
            },

            formatDate(date) {
                return moment(date).format('dddd D MMMM Y')
            },

            onModalClose() {
                this.errors = null;
            },

            onClickButton(sp) {
                sp.showModal();
            },

            async onAuthorizationModalAuthorize(token) {
                const response = await this.post('/espace-employes/commandes/preparation/commande/' + this.order.id + '/marquer-non-payee', {
                    authorization_token: token ? token.token : null,
                });

                if (!this.errors) {
                    this.closeModal();

                    if (!this.$root.echoConnectedWihoutErrors) {
                        window.location.reload();
                    }
                }
            },
        },

        computed: {
            authorizationTokenPayload() {
                return {
                    order_id: this.order.id,
                };
            },
        },
    }
</script>

<style lang="scss">
    .mark-order-not-paid-modal {
        :first-of-type(.modal-container) {
            max-width: 600px;
            width: auto;
        }
    }
</style>
